import { ESectionColor, Section } from '@web_opxp/components';
import React from 'react';
import SessionProgress from '../../session/SessionProgress';
import WorkoutView from '../views/WorkoutView';

const WorkoutPage = () => {
  return (
    <>
      <Section noPadding={true} color={ESectionColor.blue} className="exercise-section">
        <WorkoutView />
      </Section>
      <Section>
        <SessionProgress />
      </Section>
    </>
  );
};

export default WorkoutPage;
